// eslint-disable-next-line
import { queryFilter } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const getOrganizationByFilter = (queryFilter: queryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.organization.organizations}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getOrganizations = () => {
  const method = methods.GET;
  const url = `${urls.organization.organizations}?limit=10`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getOrganizationById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.organization.organizations}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createOrganization = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.organization.organizations}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updateOrganizationById = (payload: { id: any, name: string, description: string, abcFitnessSalesImportEnabled?: boolean }) => {
  const method = methods.PUT;
  const url = `${urls.organization.organizations}/${payload.id}`;
  const updatePayload: any = { name: payload.name, description: payload.description };
  if (payload.abcFitnessSalesImportEnabled !== undefined) {
    updatePayload.abcFitnessSalesImportEnabled = payload.abcFitnessSalesImportEnabled;
  }
  const response = execute(method, url, { authorization: true }, updatePayload);
  return response;
};

const updateStatusOrganizationById = (payload: { id: any, isActive: boolean }) => {
  const method = methods.PATCH;
  const url = `${urls.organization.organizations}/${payload.id}`;
  const response = execute(method, url, { authorization: true }, { isActive: payload.isActive });

  return response;
};

const updateOrganizationImage = (payload: { id: string, file?: any }) => {
  const { id, file } = payload;
  const method = methods.POST;
  const url = `${urls.organization.organizations}/${id}/uploadimage`;
  const response = execute(method, url, { authorization: true }, file, true);
  return response;
};

const setOrgCookie = (id: any) => {
  const method = methods.GET;
  const url = `${urls.organization.organizations}/${id}/set-context`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const confirmAndSaveOrgProfileImage = (payload: { organizationId: string, fileName?: any }) => {
  const method = methods.PUT;
  const url = `${urls.organization.organizations}/confirmAndSaveFile`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const getOrganizationIntegrationConfig = (organizationId: string, vendor: string) => {
  const method = methods.GET;
  const url = `${urls.organization.organizations}/${organizationId}/integrations/${vendor}`;
  const response = execute(method, url, { authorization: true });
  return response;
};

const updateOrganizationIntegrationConfig = (organizationId: string, vendor: string, payload: any) => {
  const method = methods.PUT;
  const url = `${urls.organization.organizations}/${organizationId}/integrations/${vendor}`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

export {
  getOrganizationByFilter,
  getOrganizationById,
  updateOrganizationById,
  getOrganizations,
  createOrganization,
  updateStatusOrganizationById,
  setOrgCookie,
  updateOrganizationImage,
  confirmAndSaveOrgProfileImage,
  getOrganizationIntegrationConfig,
  updateOrganizationIntegrationConfig,
};
